import * as React from 'react';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { flow } from 'lodash';
import { Button, Col, Row } from 'react-bootstrap';
import { IStore } from '../../../../../../../../../redux/IStore';
import { IMtaFormNames } from '../../../../../../../../../services/mta/models';

type TravellerType = 'child' | 'adult';

interface ITravellerTypeConfig {
  min: number;
  max: number;
}

interface IGroupType {
  adult: ITravellerTypeConfig;
  child?: ITravellerTypeConfig;
}

interface IGroupTypeMap {
  [type: string]: IGroupType;
}

const groupTypeTravellerMap: IGroupTypeMap = {
  individual: {
    adult: {
      min: 1,
      max: 1,
    },
    child: {
      min: 0,
      max: 0,
    },
  },
  couple: {
    adult: {
      min: 2,
      max: 2,
    },
    child: {
      min: 0,
      max: 0,
    },
  },
  family: {
    adult: {
      min: 2,
      max: 2,
    },
    child: {
      min: 1,
      max: 5,
    },
  },
  family_one_adult: {
    adult: {
      min: 1,
      max: 1,
    },
    child: {
      min: 1,
      max: 5,
    },
  },
  group: {
    adult: {
      min: 1,
      max: 10,
    },
    child: {
      min: 0,
      max: 9,
    },
  },
};

class MTARemoveTravellers extends React.Component<any, any> {
  private getAll = (type: TravellerType, fields) => fields.getAll().filter((traveller) => traveller.type === type);

  public state = {
    showAddressField: false,
  };

  private renderFields(type: TravellerType) {
    const { fields, i18n, travellerGroup, travellers } = this.props;

    return this.getAll(type, fields).map((traveller, index) => {
      const fieldIndex = this.props.getIndex(traveller.id, fields);
      const disableRemoveOnLeadTraveller = type === 'adult' && fieldIndex === 0;
      const disableOnGroups = travellerGroup === 'group' && travellers.length === 2;
      const isRemoved = this.props.travellersToRemove.includes(traveller.id)

      return (
        <div key={fieldIndex} className={isRemoved ? 'removed-traveller' : ''}>
          <hr style={{margin: '0px', padding: '10px 0px'}}/>
          <div>
            <div>
              <Row className={'dynamic-row'}>
                <Col xs={3} className="full-width-xs bold primary-text">{traveller.firstName}&nbsp;{traveller.lastName}</Col>
                <Col xs={3} className="full-width-xs">
                  {index === 0 && type === 'adult' &&
                    (<div>{i18n.quote.tripDetails.traveller.lead}</div>)}
                  {(index > 0 || type !== 'adult') &&
                    (<div>{i18n.quote.tripDetails.traveller[type]}
                      &nbsp;{index + 1}</div>)}
                </Col>
                <Col xs={3} className="full-width-xs">Date of Birth: {traveller.dob}</Col>
                <Col xs={3}>
                  {(!disableRemoveOnLeadTraveller && !disableOnGroups && !isRemoved) && (
                    <Button
                      bsStyle="default"
                      onClick={this.props.handleRemoveField(traveller.id, fields)}
                      className="medium-width">
                      Remove
                    </Button>
                  )}

                  {isRemoved && (
                    <Button
                      bsStyle="default"
                      onClick={this.props.handleRestoreField(traveller.id)}
                      className="medium-width">
                      Remove
                    </Button>
                  )}
                </Col>
              </Row>

            </div>
          </div>
        </div>
      );
    });
  }

  public render() {
    const { groupType } = this.props;
    const config = groupTypeTravellerMap[groupType ? groupType : ''];

    return (
      <div style={{ marginBottom: '5px' }}>
        <div style={{ margin: '20px 0 20px 0' }}>
          <p>
            Please select which traveller you wish to remove. Please note you are unable to remove the lead traveller.
            If you need to discuss further, please <a className="pointer" href={'https://www.admiral.com/contact-us/travel'} target={'_blank'}>contact us</a>.
          </p>
        </div>

        <div className={'primary-text bold '}>Travellers</div>
        <div>
          {this.renderFields('adult')}
        </div>
        <div className={config.child.max === 0 ? 'hidden' : ''}>
          <div>
            {this.renderFields('child')}
          </div>
        </div>
      </div>
    );
  }
}

let selector;

export default flow([
  (component) => {
    selector = formValueSelector(IMtaFormNames.COVER_DETAILS);

    return component;
  },
  connect(
    (state: IStore) => {
      const tripType = selector(state, 'data.attributes.metadata.scheme_type');
      const travellers = selector(state, 'data.attributes.travellers');
      const channel = state.branding.channel;
      const metadata = selector(state, 'data.attributes.metadata');
      const travellerGroup = selector(state, 'data.attributes.metadata.traveller_group');

      return {
        selectedPolicy: state.mta.selectedPolicy,
        tripType,
        travellers,
        channel,
        metadata,
        travellerGroup,
      };
    },
  ),
])(MTARemoveTravellers);
